import React, { useMemo, useState } from 'react';
import { FaTimes } from 'react-icons/fa';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ExternalGuestsInput = ({
    guestEmails = [],
    onChange,
    registeredUsers = [],
    error,
    label = 'Invite Members (Outside Organization)',
    placeholder = 'Search by email',
}) => {
    const [value, setValue] = useState('');
    const [localError, setLocalError] = useState('');

    const registeredEmails = useMemo(
        () => new Set((registeredUsers || []).map(user => String(user.email || '').toLowerCase())),
        [registeredUsers]
    );

    const addEmail = () => {
        const email = value.trim().toLowerCase();
        setLocalError('');

        if (!email) return;
        if (!EMAIL_RE.test(email)) {
            setLocalError('Enter a valid email address.');
            return;
        }
        if (registeredEmails.has(email)) {
            setLocalError('This user already exists. Please invite them from Invite Members.');
            return;
        }
        if (guestEmails.some(existing => existing.toLowerCase() === email)) {
            setLocalError('This email is already added.');
            return;
        }

        onChange([...guestEmails, email]);
        setValue('');
    };

    const removeEmail = (email) => {
        onChange(guestEmails.filter(existing => existing.toLowerCase() !== email.toLowerCase()));
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ',') {
            event.preventDefault();
            addEmail();
        }
    };

    return (
        <div className="sml-input-group full-width external-guests-group">
            <label className="project-form-label">{label}</label>
            <div className={`external-guests-field ${(error || localError) ? 'error' : ''}`}>
                <input
                    type="email"
                    value={value}
                    placeholder={placeholder}
                    onChange={(event) => {
                        setValue(event.target.value);
                        setLocalError('');
                    }}
                    onKeyDown={handleKeyDown}
                />
                <button
                    type="button"
                    className="external-guests-invite-btn"
                    onClick={addEmail}
                    disabled={!value.trim()}
                >
                    Invite
                </button>
            </div>
            {guestEmails.length > 0 && (
                <div className="external-guests-chips">
                    {guestEmails.map(email => (
                        <span key={email} className="external-guest-chip">
                            {email}
                            <button type="button" onClick={() => removeEmail(email)} aria-label={`Remove ${email}`}>
                                <FaTimes size={10} />
                            </button>
                        </span>
                    ))}
                </div>
            )}
            {(error || localError) && <div className="project-form-error">{error || localError}</div>}
        </div>
    );
};

export default ExternalGuestsInput;
